import React, { useCallback, useRef, useEffect} from 'react';
import useLocalVideoToggle from '../../hooks/useLocalVideoToggle';
import useVideoContext from '../../hooks/useVideoContext';
import useRoomState from '../../hooks/useRoomState';
import { useTwilioAppState } from '../../state';
import { CONSUMER } from '../../constants';
import { Logger } from '../../utils';



export default function ToggleVideoButton(props) {
    const [isVideoEnabled, toggleVideoEnabled] = useLocalVideoToggle();
    const lastClickTimeRef = useRef(0);
    const toggleCount = useRef(0);
    const roomState = useRoomState();
    const isReconnecting = roomState === 'reconnecting';
    const enableVirtualWaitingRoom = window && window.serverData && window.serverData.data ? window.serverData.data.enableVirtualWaitingRoom : false;



    const { localTracks, isPublishingTracks, isAcquiringLocalTracks } = useVideoContext();
    const videoTrack = localTracks.find(track => track.name.includes('camera'));
    const { source } = useTwilioAppState();

    useEffect(() => {
        if (enableVirtualWaitingRoom && source === CONSUMER) {
            if (props.showWaitingMsg && !isReconnecting && !isAcquiringLocalTracks && !isPublishingTracks && videoTrack && toggleCount.current !== 1) {
                toggleVideo();
                toggleCount.current = 1;
            }
            else if (!props.showWaitingMsg && !videoTrack && toggleCount.current === 1) {    // we only want to toggleVideo if control had reached to previous if otherwise not needed at all.
                toggleVideo();
                toggleCount.current = 2;
            }
        }
    }, [props.showWaitingMsg, videoTrack, isPublishingTracks, isAcquiringLocalTracks, isReconnecting,enableVirtualWaitingRoom]);

    const toggleVideo = useCallback(() => {
        Logger(`UI.Twilio.Room.Camera.${isVideoEnabled ? "Mute" : "Unmute"}.Clicked`, new Date());
        if (Date.now() - lastClickTimeRef.current > 500) {
            lastClickTimeRef.current = Date.now();
            toggleVideoEnabled();
        }
    }, [toggleVideoEnabled]);

    return (
        <React.Fragment>
            <button type="button" className={`btn${props.disabled ? " disabled-style" : ""}`} disabled={props.disabled} onClick={toggleVideo} id="mute-video"><span className={`${isVideoEnabled ? " icon-camera" : " icon-camera-off"}`} /></button>
        </React.Fragment>
    );
}
